module.exports = __webpack_public_path__ + "img/products_big_can_mojito.14c69be4.png";